export default __webpack_public_path__ + "static/media/off-14.08a714d0.png";